'use client';

import clsx from 'clsx';
import { SwiperSlide, type SwiperSlideProps } from 'swiper/react';

import styles from './index.module.scss';

/**
 * Carousel Slide component.
 *
 * @see https://swiperjs.com/react#swiperslide-props
 */

const CarouselSlide = ({ children, className, ...props }: SwiperSlideProps) => {
  const classes = clsx(styles.slide, className);

  return (
    <SwiperSlide className={classes} {...props}>
      {children}
    </SwiperSlide>
  );
};

/**
 * Setting the display name to `SwiperSlide`, otherwise the library is unable to render re-exported slides.
 *
 * @see https://github.com/nolimits4web/swiper/issues/4084#issuecomment-2483712943
 */

CarouselSlide.displayName = 'SwiperSlide';

export default CarouselSlide;
